import { render, staticRenderFns } from "./ClockComponent.vue?vue&type=template&id=c3c36f3a"
import script from "./ClockComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClockComponent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports